module.exports = "pegasus_template/assets/tech/medium/4.jpg";